module.exports = __webpack_public_path__ + "static/img/56-2.1d0d3fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/56-2.jpg
// module id = z9i8
// module chunks = 0